import { useGetCompareColors } from '@modules/quantify/hooks/useGetCompareColors';
import { Stack } from '@mui/material';
import { Box, SxProps } from '@mui/system';
import { ReactNode } from 'react';

interface CompareFieldGroupWrapperProps {
  fieldA: ReactNode;
  fieldB: ReactNode;
  relationIndicatorSx?: SxProps;
}

export const CompareFieldGroupWrapper = ({
  fieldA,
  fieldB,
  relationIndicatorSx,
}: CompareFieldGroupWrapperProps) => {
  const { colorA, colorB } = useGetCompareColors();

  const renderFieldRelationIndicator = (color: string) => {
    return (
      <Box
        sx={{
          backgroundColor: color,
          borderRadius: '50%',
          p: 1,
          ...relationIndicatorSx,
        }}
      />
    );
  };

  return (
    <Box>
      <Stack direction="row" spacing={1} pb={1}>
        <Box>
          {renderFieldRelationIndicator(colorA)}
          <Box
            sx={{
              mt: '-2px',
              ml: '6.5px',
              height: '100%',
              width: '3px',
              backgroundImage: `linear-gradient(to bottom, ${colorA}, ${colorB})`,
              minWidth: 'fit-content',
            }}
          />
        </Box>
        <Box width="100%" minWidth={0}>
          {fieldA}
        </Box>
      </Stack>
      <Stack direction="row" alignItems="flex-start" spacing={1}>
        {renderFieldRelationIndicator(colorB)}
        <Box width="100%" minWidth={0}>
          {fieldB}
        </Box>
      </Stack>
    </Box>
  );
};
